import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageProvider } from "src/app/services";
import { routeConstant } from "src/app/utils/constant/route.constant";
import { environment } from "src/environments/environment";
import { KYC_REVIEW_STATUS, KYC_STATUS } from "../constants/eventsConstant";

export const PreAuthGuard = () => {
  const localStorage = inject(LocalStorageProvider);
  const router = inject(Router);
  let userInfo = localStorage.getItem("userInfo");
  const { requestId } = environment;

  let isAuthenticated =
    (localStorage.getItem("refreshToken") &&
      userInfo?.kyc_review_status === KYC_REVIEW_STATUS.completed &&
      userInfo?.kyc_status === KYC_STATUS.Approved) ||
    false;
  const currentAbsoluteUrl = window.location.href;
  const urlArray = currentAbsoluteUrl.split("/");
  const routeEndpoint = urlArray[urlArray.length - 1];
  const routeTo = routeEndpoint.split("?")[0]; // It has the route which needs to be visited like contact-us-page, landing-page etc.
  const queryId = currentAbsoluteUrl.split("q=")[1]; // contains query ID passed via email URL

  if (isAuthenticated) {
    if (queryId === requestId) {
      router.navigateByUrl(`/${routeConstant.post_auth}/${routeTo}`);
    } else {
      router.navigateByUrl(routeConstant.dashboard_post_auth);
    }
    return true;
  }

  return !isAuthenticated;
};
